// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__pu-7B","errors":"Errors_errors__33gYe"};